import { ICaptcha } from './../types/appDataTypes';
import { action } from "typesafe-actions"
import { IUserInfo, IEntryDocuments, IDocumentIds } from "../types/appDataTypes"
import { TSteps, IErrorState, IEntryViewState } from "../reducers/appReducers"
import { ILangPack, IAppConfig, TLanguage } from "../reducers/configReducers";
import { IParentInfo, IAddressOther, IAddressSG, IArtistInfo, IEntry } from "../types/appDataTypes";
import { IAddressResponse } from "../utils/api";
// use typescript enum rather than action constants
export enum actionTypes {
  GOTO_STEP = "GOTO_STEP",
  UPDATE_APP_STATUS = "UPDATE_APP_STATUS",
  UPDATE_USER_DATA = "UPDATE_USER_DATA",
  UPDATE_PARENT_DATA = "UPDATE_PARENT_DATA",
  UPDATE_ADDRESS_DATA = "UPDATE_ADDRESS_DATA",
  UPDATE_ARTIST_DATA = "UPDATE_ARTIST_DATA",
  UPDATE_APP_CONFIG = "UPDATE_APP_CONFIG",
  UPDATE_CONFIG = "UPDATE_CONFIG",
  ADD_MESSAGE = "ADD_MESSAGE",
  POP_MESSAGE = "POP_MESSAGE",
  UPDATE_ENTRY = "UPDATE_ENTRY",
  DELETE_ENTRY = "DELETE_ENTRY",
  SET_IS_CALLING_API = "SET_IS_CALLING_API",
  UPDATE_RETRIEVED_ADDRESS = "UPDATE_RETRIEVED_ADDRESS",
  UPDATE_ENTRY_DOCUMENTS = "UPDATE_ENTRY_DOCUMENTS",
  UPDATE_ENTRY_SINGLE_DOCUMENT = "UPDATE_ENTRY_SINGLE_DOCUMENT",
  SET_APPLICATION_UPDATED = "SET_APPLICATION_UPDATED",
  UPDATE_ERROR_RETRY_COUNT = "UPDATE_ERROR_RETRY_COUNT",
  UPDATE_RECAPTCHA_VERIFIED = "UPDATE_RECAPTCHA_VERIFIED",
}



export const appActions = {
  gotoStep: (step: TSteps, state?: IErrorState | IEntryViewState) =>
    action(actionTypes.GOTO_STEP, { step, state }),

  updateAppConfig: (appConfig: IAppConfig) =>
    action(actionTypes.UPDATE_APP_CONFIG, appConfig),

  updateLanguage: (lang: TLanguage, langPack: ILangPack) =>
    action(actionTypes.UPDATE_CONFIG, { lang, langPack }),

  updateTNCData: (tncData: Record<string, string>) =>
    action(actionTypes.UPDATE_CONFIG, { tncData }),

  addMessage: (message: JSX.Element) =>
    action(actionTypes.ADD_MESSAGE, message),

  popMessage: () =>
    action(actionTypes.POP_MESSAGE),

  setIsCallingApi: (isCallingApi: boolean) =>
    action(actionTypes.SET_IS_CALLING_API, isCallingApi),

  updateRetrievedAddress: (address: IAddressResponse) =>
    action(actionTypes.UPDATE_RETRIEVED_ADDRESS, address),

  updateEntryDocuments: (entryId: string, documents: IEntryDocuments) =>
    action(actionTypes.UPDATE_ENTRY_DOCUMENTS, { entryId, documents }),

  updateEntrySingleDocument: (entryId: string, documentId: IDocumentIds, value: string) =>
    action(actionTypes.UPDATE_ENTRY_SINGLE_DOCUMENT, { entryId, documentId, value }),

  setApplicationUpdated: (isAppUpdated: boolean) =>
    action(actionTypes.SET_APPLICATION_UPDATED, isAppUpdated),

  updateErrorRetryCount: (errorRetryCount: number) =>
    action(actionTypes.UPDATE_ERROR_RETRY_COUNT, errorRetryCount),
};


export const userInfoActions = {
  updateUserInfo: (userInfo: IUserInfo) =>
    action(actionTypes.UPDATE_USER_DATA, userInfo),

  updateParentInfo: (parentInfo: IParentInfo) =>
    action(actionTypes.UPDATE_PARENT_DATA, parentInfo),

  updateAddressInfo: (addressInfo: IAddressOther | IAddressSG) =>
    action(actionTypes.UPDATE_ADDRESS_DATA, addressInfo),

  updateArtistInfo: (artistInfo: IArtistInfo) =>
    action(actionTypes.UPDATE_ARTIST_DATA, artistInfo),

  updateEntry: (entryInfo: IEntry, entryIndex: number) =>
    action(actionTypes.UPDATE_ENTRY, { entryInfo, entryIndex }),

  deleteEntry: (entryInfo: IEntry) =>
    action(actionTypes.DELETE_ENTRY, entryInfo)
}

export const ReCaptchAction = {
  updateCaptureVerified: (captchaVerified: ICaptcha) =>
    action(actionTypes.UPDATE_RECAPTCHA_VERIFIED, captchaVerified),
}